import React from 'react';
import handleDummyAction from '../../utils/Dummy/handleDummyAction';
const defaultValue = {
    loading: false,
    isEditSessionActive: true,
    beginEditSession: handleDummyAction,
    cancelEditSession: handleDummyAction,
};
const EditSessionContext = React.createContext(defaultValue);
export default EditSessionContext;
